import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedClass: '',
  selectedSubject: '',
  classData: {},
};

export const classSubjectSlice = createSlice({
  name: 'classSubject',
  initialState,
  reducers: {
    setSelectedClass: (state, action) => {
      state.selectedClass = action.payload;
    },
    setSelectedSubject: (state, action) => {
      state.selectedSubject = action.payload;
    },
    setClassData: (state, action) => {
      state.classData = { ...action.payload }
    }
  },
});

export const { setSelectedClass, setSelectedSubject, setClassData } = classSubjectSlice.actions;

export default classSubjectSlice.reducer;

